import apiClient from './api-client';

const post = endpoint => data => apiClient.post(endpoint, data);

export const getNotification = post('getNotification');
export const markAllAsRead = post('markAllAsRead');
export const sendNotificationToUsers = post('sendNotificationToUsers');
export const sendTestNotificationEmail = post('sendTestNotificationEmail');
export const getNotificationToUsers = post('getNotificationToUsers');
